import * as React from "react";
import styled from "styled-components";
import { CheckOutlined } from "@ant-design/icons";

const Container = styled.div<{ width: number }>`
  z-index: 9999;
  background-color: white;
  padding: 10px 0;
  border-radius: 3px;
  .ellipse {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%),
    0 9px 28px 8px rgb(0 0 0 / 5%);
  .item {
    ${(p) => `width:${p.width}px;`}
    border-bottom: 1px solid #ddd;
    margin-bottom: 1px;
    padding: 6px 6px;
    color: rgba(0, 0, 0, 0.65);
    transition: all 0.3s;
    text-align: center;
    &:hover {
      color: rgb(0, 0, 0);
      transition: all 0.3s;
    }
  }
  .active {
    color: rgb(24, 144, 255) !important;
    transition: all 0.3s;
  }
  .title {
    line-height: 25px;
    text-align: center;
    margin-bottom: 5px;
    font-size: 13px;
    color: #666;
  }
  transition: all 0.3s;
  .item:last-child {
    border-bottom: none !important;
  }
`;

interface ItemProps {
  k: string;
  v: string;
  c?: boolean; // 不能被选中，只能点击?
}

interface CmenuProps {
  items: Array<ItemProps>;
  title?: string;
  onSelect: (
    itemkey: string,
    checked: boolean,
    selectedItems: Array<string>
  ) => void;
  selectedItems: Array<string>;
  single?: boolean;
  width?: number;
}

const Cmenu: React.FunctionComponent<CmenuProps> = ({
  items = [],
  onSelect = () => {},
  selectedItems = [],
  title,
  single = false,
  width = 180,
}) => {
  const changeHandler = (k: string) => {
    if (single && k !== selectedItems[0]) {
      onSelect(k, true, [k]);
      return;
    } else if (single && k === selectedItems[0]) {
      return;
    }
    let retArr: Array<string> = [];
    const idx = selectedItems.findIndex((x) => x === k);
    const item = items.find((x) => x.k === k);
    if (idx >= 0) {
      selectedItems.splice(idx, 1);
      retArr = [...selectedItems];
    } else {
      if (!item.c) {
        retArr = [...selectedItems, k];
      } else {
        retArr = [...selectedItems];
      }
    }
    onSelect(k, idx < 0, retArr);
  };

  return (
    <Container width={width}>
      {title && <div className="title">{title}</div>}

      {items.map((item: ItemProps) => (
        <div
          className={`item pointer ${
            selectedItems.indexOf(item.k) >= 0 ? "active" : ""
          }`}
          key={item.k}
          onClick={() => changeHandler(item.k)}
        >
          {!item.c && selectedItems.indexOf(item.k) >= 0 ? (
            <>
              <CheckOutlined className="fl mt4"/>
              <div
                className={!item.c ? "ml20 ellipse" : "ellipse"}
                title={item.v}
              >
                {item.v}
              </div>
            </>
          ) : (
            <div
              className={!item.c ? "ml20 ellipse" : "ellipse"}
              title={item.v}
            >
              {item.v}
            </div>
          )}
        </div>
      ))}
    </Container>
  );
};

export default Cmenu;
